import { defaultScaffold } from "@Light/scaffold/default";
import { PortalHeader } from "./components/PortalHeader";

export const scaffold = {
  ...defaultScaffold,
  page: {
    ...defaultScaffold.page,
    splashImage: false, // PCX-654, temporarily disabled
    header: {
      ...defaultScaffold.page.header,
      header: PortalHeader,
    },
  },
};
